import { render, staticRenderFns } from "./BeforeArchive.vue?vue&type=template&id=2e7150dd&scoped=true&"
import script from "./BeforeArchive.vue?vue&type=script&lang=js&"
export * from "./BeforeArchive.vue?vue&type=script&lang=js&"
import style0 from "./BeforeArchive.vue?vue&type=style&index=0&id=2e7150dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7150dd",
  null
  
)

export default component.exports